import { ApiService } from './../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-welcome-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './welcome-widget.component.html',
  styleUrls: ['./welcome-widget.component.scss']
})
export class WelcomeWidgetComponent implements OnInit, OnChanges {
  showWelcomePost: boolean = false
  @Input() widgetDesc: string;
  @Input() suggestion: any;
  headerTitle: string = 'Welcome';
  following: boolean = false
  constructor( private a_route: ActivatedRoute, private api: ApiService) { }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if(res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
        this.headerTitle=res.menu;
    }
    if(res.showWelcomePost=="true"){
      this.showWelcomePost = true

    }
  })
  }

  follow(){
    var data: any = {}
    data.userId = localStorage.getItem('userId')
    data.followerUserId = localStorage.getItem('userId')


    this.api.create('user/followUser', data).subscribe(res=>{
      if(res.code == '00000'){
        this.following = true
      }
    })
  }


  // profileStatus() {
  //   let datas: any = {};
  //   datas.userId = localStorage.getItem('userId')
  //   this.api.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(res => {

  // })

  // }
}
